module.exports = __webpack_public_path__ + "static/retmon-pdf-329bc55e00b0aeab5ff0023a636990ec.svg";